import { Card, CardHeader, Stack } from '@mui/material';
import { PhotoStudioRegularHoliday } from 'codegen/axios/photo/photo_studio';
import { FC, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import EditButton from 'src/components/atoms/edit-button';
import DeleteModal from 'src/components/molecules/delete-modal';
import DetailCard from 'src/components/molecules/detail-card';
import { regularHolidayFetchOrganize } from 'src/functions/fetch-value-organize';
import useFetch from 'src/hooks/use-fetch';
import usePush from 'src/hooks/use-push';
import { defaultValues } from 'src/components/organisms/photo-studio/detail/regular-holiday/form';

export const PhotoStudioRegularHolidayCard: FC = () => {
  /* 定数宣言 */
  const title = '定休日';

  /* hook宣言 */
  const { id: photoStudioId } = useParams();
  const navigate = useNavigate();
  const push = usePush();
  const [listUpdate, setListUpdate] = useState(0);

  /* データ取得 */
  const { fetchedData: responseData } = useFetch<PhotoStudioRegularHoliday>({
    iniState: defaultValues,
    reqProp: {
      pathKey: 'regularHoliday',
      queryParams: { photoStudioId },
    },
    observable: [listUpdate],
  });

  const handleRegularHolidayEditButtonOnClick = () => {
    responseData.photoStudioId === undefined
      ? navigate(`/photoStudioStaff/setting/photoStudio/${photoStudioId}/regularHoliday/new`)
      : navigate(
          `/photoStudioStaff/setting/photoStudio/${photoStudioId}/regularHoliday/${responseData.photoStudioRegularHolidayId}/edit`
        );
  };

  const onDelete = () => {
    new Promise((resolve) =>
      push(resolve, {
        reqProp: {
          pathKey: 'regularHoliday',
          method: 'delete',
          pathParam: responseData.photoStudioRegularHolidayId,
        },
        aftProp: {
          resolve,
          nextPath: `/setting/photoStudio/${photoStudioId}`,
          showMessage: {
            state: { snackBar: { open: true, viewType: 'info', message: '削除しました' } },
          },
        },
      })
    ).then(() => {
      setListUpdate(listUpdate + 1);
    });
  };

  return (
    <>
      <Stack direction="row" alignItems="center" justifyContent="flex-end" mt={9}>
        {responseData.photoStudioRegularHolidayId !== undefined && (
          <DeleteModal
            sx={{
              bgcolor: 'background.paper',
              minWidth: 50,
              minHeight: 47,
              boxShadow: 1,
              borderRadius: 2,
              ml: 2,
            }}
            OnDelete={onDelete}
          />
        )}

        <EditButton handleEditOnClick={handleRegularHolidayEditButtonOnClick} />
      </Stack>

      <Card sx={{ mt: 5 }}>
        <CardHeader title={title} sx={{ mb: 3, mt: 1 }} />

        <DetailCard
          defaultValues={regularHolidayFetchOrganize(responseData)}
          labelProperty={{
            営業日: 'success',
            定休日: 'info',
          }}
        />
      </Card>
    </>
  );
};
